<template src="./assettemplates.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
      showstring: function (data) {
        if (data == "" || data == null) {
          return "";
        } else {
          return data.replaceAll("_", " ");
        }
      },
    },
    data() {
      return {
        ShowLoader: false,
        ShowTemplateAddModel: false,
        AssetTemplates: [],
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        SearchForm: {
          Name: "",
        },
        SubmitTemplate: {},
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.GetCompanySubscription();
    },
    methods: {
      GetTemplatesList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Template.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.ShowLoader = false;
            this.AssetTemplates = Response.data.Templates;
          }
        });
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
          this.GetTemplatesList();
        } else {
          this.$router.push("/settings");
        }
      },
      DeleteAssetTemplate(tempId) {
        this.$swal({
          title: "Are you sure You want to delete this Asset Template?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Assets.Template.Delete, {
              token: localStorage.getItem("token"),
              id: tempId,
            }).then((Response) => {
              this.$swal(
                "Asset Template Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                this.GetTemplatesList(this.Category);
              });
            });
          }
        });
      },
      EditAssetTemplate(Template) {
        this.ShowTemplateAddModel = true;
        this.SubmitTemplate.category_name = Template.category_name;
        this.SubmitTemplate.subcategory_name = Template.subcategory_name;
        this.SubmitTemplate.name = Template.name;
        this.SubmitTemplate.id = Template.id;
      },
      EditTemplateSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitTemplate.name) {
          error = true;
          errorStr += "Please Enter Template Name";
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Editing Template...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Assets.Template.Update, {
            token: localStorage.getItem("token"),
            id: this.SubmitTemplate.id,
            name: this.SubmitTemplate.name,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              this.ShowTemplateAddModel = false;
              this.GetTemplatesList();
              this.$swal("Template Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
    },
    
    
  };
</script>

<style type="text/css"></style>
